import {useEffect, useState} from "react";
import PlayerFightPowerTable from "./components/globalranking/playerfightpowertable";
import {GlobalRankingService} from "./services/GlobalRankingService";
import {useNavigate} from "react-router-dom";

const GlobalRanking = () => {
    const navigate = useNavigate();

    const {getFightPowerRanking} = GlobalRankingService();

    /**
     * player_fightpower
     * consortia_fightpower
     * player_money
     */
    const [currentTab, setCurrentTab] = useState("player_fightpower");
    const [rankingItems, setRankingItems] = useState([]);
    const [rankingLoading, setRankingLoading] = useState(false);

    useEffect(() => {
        playerFightPowerRankingLoader();
    }, []);

    const playerFightPowerRankingLoader = async () => {
        const cachedRanking = localStorage.getItem("global_fightPowerRanking");
        if (cachedRanking) {
            setRankingItems(JSON.parse(cachedRanking));
        } else {
            setRankingLoading(true);
        }

        try {
            const response = await getFightPowerRanking(false, 10);
            setRankingItems(response.data);
            localStorage.setItem("global_fightPowerRanking", JSON.stringify(response.data));
        } catch (err) {
            console.error("Erro ao buscar ranking:", err);
        }
        setRankingLoading(false);
    };

    return (
        <div className={"flex items-center justify-center p-4 globalranking-page"}>
            <div className="ranking-container bg-white w-full max-w-6xl">
                {/*Header*/}
                <div className="bg-gray-800 text-white px-8 py-6 flex items-center justify-between">
                    <div className="flex items-center">
                        <div className="w-14 h-14 bg-blue-500 rounded-lg flex items-center justify-center mr-4">
                            <i className="fas fa-trophy text-white text-2xl"></i>
                        </div>
                        <h1 className="text-3xl font-bold">DDtank <span className="text-blue-300">Ranking Global</span>
                        </h1>
                    </div>
                    <button onClick={() => navigate('/')} className="flex items-center text-blue-300 hover:text-blue-100">
                        <i className="fas fa-sign-in-alt mr-2"></i>
                        <span>Voltar</span>
                    </button>
                </div>

                {/*Main Content*/}
                <div className="p-8">

                    {/*Ranking Tabs*/}
                    <div className="mb-6">
                        <div className="border-b border-gray-200">
                            <nav className="-mb-px flex space-x-8">
                                <button onClick={() => setCurrentTab("player_fightpower")}
                                   className={`${currentTab === "player_fightpower" ? "tab-active whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm" : "whitespace-nowrap py-4 px-1 border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 font-medium text-sm"}`}>
                                    <i className="fas fa-crown mr-2"></i> Jogadores mais fortes
                                </button>
                                {/*<button onClick={() => setCurrentTab("consortia_fightpower")}*/}
                                {/*   className={`${currentTab === "consortia_fightpower" ? "tab-active whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm" : "whitespace-nowrap py-4 px-1 border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 font-medium text-sm"}`}>*/}
                                {/*    <i className="fas fa-users mr-2"></i> Sociedades mais fortes*/}
                                {/*</button>*/}
                                {/*<button onClick={() => setCurrentTab("player_money")}*/}
                                {/*   className={`${currentTab === "player_money" ? "tab-active whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm" : "whitespace-nowrap py-4 px-1 border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 font-medium text-sm"}`}>*/}
                                {/*    <i className="fas fa-coins mr-2"></i> Jogadores mais ricos*/}
                                {/*</button>*/}
                            </nav>
                        </div>
                    </div>

                    {/*Ranking Table*/}
                    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                        <div className="grid grid-cols-12 bg-gray-100 text-gray-700 font-medium text-sm">
                            <div className="col-span-1 py-3 px-4 text-center">#</div>
                            <div className="col-span-6 py-3 px-4">Jogador</div>
                            <div className="col-span-2 py-3 px-4 text-center">Sociedade</div>
                            <div className="col-span-2 py-3 px-4 text-center">Nível</div>
                            {/*<div className="col-span-1 py-3 px-4 text-center">VIP</div>*/}
                        </div>

                        <div className="divide-y divide-gray-200">

                            <PlayerFightPowerTable items={rankingItems}></PlayerFightPowerTable>

                        </div>
                    </div>
                </div>

                {/*Footer*/}
                <div className="bg-gray-800 text-white px-6 py-4 text-center text-sm">
                    <p>DDtank Splush © 2025 - Todos os direitos reservados</p>
                    <div className="flex justify-center space-x-4 mt-2">
                        <a href="#" className="hover:text-blue-300"><i className="fab fa-facebook"></i></a>
                        <a href="#" className="hover:text-blue-400"><i className="fab fa-twitter"></i></a>
                        <a href="#" className="hover:text-red-400"><i className="fab fa-youtube"></i></a>
                        <a href="#" className="hover:text-purple-400"><i className="fab fa-discord"></i></a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GlobalRanking;